/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Strength_Levels_TitleInputs */

const en_us2_exercise_personal_strength_levels_title = /** @type {(inputs: Exercise_Personal_Strength_Levels_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strength levels`)
};

const pt_br2_exercise_personal_strength_levels_title = /** @type {(inputs: Exercise_Personal_Strength_Levels_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Níveis de força`)
};

const es_419_exercise_personal_strength_levels_title = /** @type {(inputs: Exercise_Personal_Strength_Levels_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveles de fuerza`)
};

const pt_pt2_exercise_personal_strength_levels_title = /** @type {(inputs: Exercise_Personal_Strength_Levels_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Níveis de força`)
};

const fr_fr2_exercise_personal_strength_levels_title = /** @type {(inputs: Exercise_Personal_Strength_Levels_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveaux de force`)
};

const de_de2_exercise_personal_strength_levels_title = /** @type {(inputs: Exercise_Personal_Strength_Levels_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kraftniveaus`)
};

const it_it2_exercise_personal_strength_levels_title = /** @type {(inputs: Exercise_Personal_Strength_Levels_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livelli di forza`)
};

/**
* | output |
* | --- |
* | "Strength levels" |
*
* @param {Exercise_Personal_Strength_Levels_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_levels_title = /** @type {((inputs?: Exercise_Personal_Strength_Levels_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_Levels_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_levels_title(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_levels_title(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_levels_title(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_levels_title(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_levels_title(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_levels_title(inputs)
	return en_us2_exercise_personal_strength_levels_title(inputs)
});
export { exercise_personal_strength_levels_title as "exercise-personal.strength_levels_title" }